import React, { memo } from 'react';
import { CheckmarkCircle16Filled, Circle16Regular } from '@fluentui/react-icons';
import { extractBlockItems } from './structuredBlockUtils';
import styles from './structuredResponse.module.css';

function ChecklistBlock({ block }) {
    const items = extractBlockItems(block);
    if (!items.length) return null;

    return (
        <section className={styles.checklistBlock} aria-label={block.title || 'Checklist'}>
            {block.title ? <h3 className={styles.blockTitle}>{block.title}</h3> : null}
            <ul className={styles.checklistList} role="list">
                {items.map((item, index) => {
                    const label = item.label || item.title || item.text;
                    if (!label) return null;
                    const completed = Boolean(item.completed ?? item.done ?? item.checked);
                    return (
                        <li
                            key={item.id || `check-${index}`}
                            className={`${styles.checklistItem} ${completed ? styles.checklistItemDone : ''}`.trim()}>
                            <span className={styles.checklistIcon} aria-hidden>
                                {completed ? <CheckmarkCircle16Filled /> : <Circle16Regular />}
                            </span>
                            <span className={styles.checklistLabel}>{label}</span>
                        </li>
                    );
                })}
            </ul>
        </section>
    );
}

export default memo(ChecklistBlock);
